import { getAiInput } from './ai'
import { getRacerIdentity } from './racer-config'
import type { AiProfile, ControlInput, SimulationState } from './types'
import { EMPTY_INPUT } from './vehicle'

const VIRTUAL_PLAYER_PROFILE: AiProfile = {
  ...getRacerIdentity('player'),
  preferredSpeed: 60,
  aggression: 0,
  driftTendency: 1,
  lineOffset: 0,
}

export function getVirtualPlayerInput(state: SimulationState): ControlInput {
  const playerId = state.race.playerId
  const player = state.vehicles.find((vehicle) => vehicle.id === playerId)
  if (!player || state.race.progress[playerId]?.recordStatus !== 'racing') return EMPTY_INPUT

  return {
    ...getAiInput(player, { vehicles: state.vehicles }, state.track, VIRTUAL_PLAYER_PROFILE),
    fire: false,
  }
}
